import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, EMPTY, Observable } from 'rxjs';
import { UrlService } from './url.service';
import { KPI } from '../models/KPI';

@Injectable({
  providedIn: 'root',
})
export class KPIService {
  private readonly url: string;

  constructor(private readonly http: HttpClient, private readonly urlService: UrlService) {
    this.url = this.urlService.generateUrl('kpi');
  }

  getKPIsData(company: string, year: number): Observable<KPI[]> {
    const params = new HttpParams()
      .set('company', company)
      .set('year', year);
    return this.http.get<KPI[]>(this.url + '/GetKpiViews', { params }).pipe(
      catchError((error: any) =>
        this.handleError(error))
    );
  }

  getKpiYears(company: string): Observable<number[]> {
    const params = new HttpParams().set('company', company);
    return this.http.get<number[]>(this.url + '/GetKpiYears', { params }).pipe(
      catchError((error: any) =>
        this.handleError(error))
    );
  }

  updateItem(kpiEntries: KPI[], isEdit: boolean, isOnlyLockChanged: boolean): Observable<void> {
      const url = `${this.url}/UpdateKpiViews?isEdit=${isEdit}&isLockChanged=${isOnlyLockChanged}`;
      return this.http.post<void>(url, kpiEntries).pipe(
        catchError((error: any) => this.handleError(error))
      );
    }

  private handleError(error: any): Observable<never> {
    return EMPTY;
  }
}
